export default "/Frontend/dist/excel-white.ba520969a79c35cf157a019b57fdd2b1.svg";